import React from "react";
import "./App.css";
import Page from "./components/Page/Page";

function App() {
  return (
    <div className="App">
      <Page />
    </div>
  );
}
// COMBAK: change all the classes to one line exports
export default App;
